import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Esito } from '../../../models/esito';
import { EsitiMeritoAddComponent } from './esiti-merito-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [esiti-merito-add-mod]',
  templateUrl: 'esiti-merito-add-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class EsitiMeritoAddMod {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('formMerito') formMerito: EsitiMeritoAddComponent;

  inizializza(urlAddMerito: string, esito: Esito, idSezioneEventi: string, urlSezioneControparti: string, idSezioneControparti: string, urlSezioneClassificazioni: string, idSezioneClassificazione: string, idPratica: string, urlSezioneEsiti: string) {
    this.formMerito.inizializza(urlAddMerito, esito, urlSezioneEsiti, idSezioneEventi, urlSezioneControparti, idSezioneControparti, urlSezioneClassificazioni, idSezioneClassificazione, idPratica);
    openModal('modalmodmeriti');
  }

  createForm() {
    this.formMerito.createForm();
  }

  manageModal() {
      closeModal('modalmodmeriti');
      this.onReturn.emit();
  }
}
